
import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import PatientViewer from './pages/patientViewer/patientViewer';
import Launcher from './pages/launcher/launcher';
import Register from './pages/Register/Register';
import { useContext, useEffect } from 'react';
import { ShowContext } from './context/Context';
import { Alert } from 'antd';


function App() {
  const { error: { message, type } } = useContext(ShowContext)
  const navigate = useNavigate()
  useEffect(() => {
    navigate("/patientViewer")
  }, [navigate])

  return (
    <div className='container'>

      {message && <Alert message={message} style={{
        width: "60%",
        margin: "auto",
        top: "116px",
        zIndex: "999"
      }} type={type || 'success'} />}
      <Routes>
        <Route path='/' element={<Launcher />} />
        <Route exact path='/patientViewer' element={<PatientViewer />} />
        <Route exact path='/register' element={<Register />} />
      </Routes>
    </div>
  );
}

export default App